import { useContext } from 'react';
import { Grid, Typography } from '@material-ui/core';
import Moment from 'react-moment';
import { appUserContext } from 'helpers/services';
import { IssueServiceType } from 'helpers/enums';
import { ticketContext } from '../../TicketContext';
import EditDetails from './EditRequest';


let DeliveryInfo = () => {
    let { currentUser } = useContext(appUserContext);
    let { ticket, productSuppliers } = useContext(ticketContext);

    return (
        <>
            <Grid container>
                <Grid item xs>
                    <Typography>{ticket.deliveryNote || '-'}</Typography>
                    <Typography variant="subtitle1">Delivery notes</Typography>
                </Grid>
                {currentUser?.canWorkOnAllTicket === true &&
                    <Grid item>
                        <EditDetails />
                    </Grid>
                }
            </Grid>
            <Grid container>
                <Grid item xs>
                    <Typography>
                        {ticket.invoiceDate ? <Moment date={ticket.invoiceDate} format="LL" /> : '-'}
                    </Typography>
                    <Typography variant="subtitle1">Invoice date</Typography>
                </Grid>
                <Grid item xs>
                    <Typography>{ticket.invoiceNumber || '-'}</Typography>
                    <Typography variant="subtitle1">Invoice number</Typography>
                </Grid>
                <Grid item xs>
                    <Typography>{ticket.invoiceQuantity || '-'}</Typography>
                    <Typography variant="subtitle1">Invoice quantity</Typography>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs>
                    <Typography>
                        {ticket.issueServiceType === IssueServiceType.None && 'No issue service type has been provided'}
                        {ticket.issueServiceType === IssueServiceType.DamagedPackages && 'Package is damaged'}
                        {ticket.issueServiceType === IssueServiceType.MissingItems && 'Items missing'}
                        {ticket.issueServiceType === IssueServiceType.MissingPackages && 'Packages missing'}
                        {ticket.issueServiceType === IssueServiceType.OvershippedItems && 'Items overshipped'}
                        {ticket.issueServiceType === IssueServiceType.DamagedItems && 'Item is damaged'}
                    </Typography>
                    <Typography variant="subtitle1">Issue service type</Typography>
                </Grid>
            </Grid>

            {(ticket.issueServiceType === IssueServiceType.DamagedPackages
                || ticket.issueServiceType === IssueServiceType.MissingPackages) &&
                <Grid container>
                    <Grid item xs={4}>
                        <Typography>{ticket.numberOfPackages || '-'}</Typography>
                        <Typography variant="subtitle1">Number of packages</Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography>{ticket.packageNumbers?.join(", ") || '-'}</Typography>
                        <Typography variant="subtitle1">Package numbers</Typography>
                    </Grid>
                </Grid>
            }

            {(ticket.issueServiceType === IssueServiceType.OvershippedItems
                || ticket.issueServiceType === IssueServiceType.MissingItems
                || ticket.issueServiceType === IssueServiceType.DamagedItems) &&
                <Grid container>
                    <Grid item xs={8}>
                        {(ticket.productBrand || ticket.productDescription) &&
                            <Typography>
                                {ticket.productSKU}&nbsp;&middot;&nbsp;
                                {ticket.productBrand && `${ticket.productBrand} `}
                                {ticket.productDescription && `${ticket.productDescription} `}
                            </Typography>
                        }
                        {!ticket.productBrand && !ticket.productDescription &&
                            <Typography>{ticket.productSKU}</Typography>
                        }
                        <Typography variant="subtitle1">Product</Typography>
                    </Grid>
                    {(ticket.issueServiceType === IssueServiceType.OvershippedItems
                        || ticket.issueServiceType === IssueServiceType.MissingItems) &&
                        <Grid item xs>
                            <Typography>{ticket.receivedQuantity || '-'}</Typography>
                            <Typography variant="subtitle1">Received quantity</Typography>
                        </Grid>
                    }
                    {ticket.issueServiceType === IssueServiceType.DamagedItems &&
                        <Grid item xs>
                            <Typography>{ticket.damagedItemQuantity || '-'}</Typography>
                            <Typography variant="subtitle1">Quantity of item damaged</Typography>
                        </Grid>
                    }
                    <Grid item xs={12}>
                        {ticket.productSupplierCode && ticket.productSupplierCode !== '' &&
                            <Typography>
                                {ticket.productSupplierCode} - {ticket.productSupplierName}
                            </Typography>
                        }
                        {productSuppliers.length > 0 && (!ticket.productSupplierCode || ticket.productSupplierCode === '') &&
                            <Typography>Multiple suppliers</Typography>
                        }
                        {productSuppliers.length <= 0 && (!ticket.productSupplierCode || ticket.productSupplierCode === '') &&
                            <Typography>-</Typography>
                        }
                        <Typography variant="subtitle1">Product supplier</Typography>
                    </Grid>
                </Grid>
            }
        </>
    )
}

export default DeliveryInfo;